/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free ideal weight calculator. Estimate your ideal body weight from height and sex using the Devine, Robinson, Miller and Hamwi formulas.`)
};

const es_iw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de peso ideal gratuita. Estima tu peso corporal ideal a partir de la altura y el sexo con las fórmulas de Devine, Robinson, Miller y Hamwi.`)
};

const de_iw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Idealgewicht-Rechner. Schätze dein Idealgewicht anhand von Körpergröße und Geschlecht mit den Formeln von Devine, Robinson, Miller und Hamwi.`)
};

const nl_iw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis ideaal-gewicht calculator. Schat je ideale lichaamsgewicht op basis van lengte en geslacht met de formules van Devine, Robinson, Miller en Hamwi.`)
};

const fr_iw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de poids idéal gratuit. Estimez votre poids corporel idéal à partir de votre taille et de votre sexe avec les formules de Devine, Robinson, Miller et Hamwi.`)
};

const it_iw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di peso ideale gratuito. Stima il tuo peso corporeo ideale da altezza e sesso con le formule di Devine, Robinson, Miller e Hamwi.`)
};

const pt_br2_iw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de peso ideal gratuita. Estime seu peso corporal ideal a partir da altura e do sexo usando as fórmulas de Devine, Robinson, Miller e Hamwi.`)
};

const pt_iw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de peso ideal gratuita. Estime o seu peso corporal ideal a partir da altura e do sexo usando as fórmulas de Devine, Robinson, Miller e Hamwi.`)
};

const ja_iw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の理想体重計算機。デバイン式、ロビンソン式、ミラー式、ハムウィ式を使い、身長と性別から理想体重を推定します。`)
};

const zh_iw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费理想体重计算器。使用 Devine、Robinson、Miller 和 Hamwi 公式，根据身高和性别估算理想体重。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_meta_description", locale)
	if (locale === "en") return en_iw_meta_description(inputs)
	if (locale === "es") return es_iw_meta_description(inputs)
	if (locale === "de") return de_iw_meta_description(inputs)
	if (locale === "nl") return nl_iw_meta_description(inputs)
	if (locale === "fr") return fr_iw_meta_description(inputs)
	if (locale === "it") return it_iw_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_iw_meta_description(inputs)
	if (locale === "pt") return pt_iw_meta_description(inputs)
	if (locale === "ja") return ja_iw_meta_description(inputs)
	return zh_iw_meta_description(inputs)
};